'use client';

import { useState } from 'react';
import { IconDownload, IconFile } from '@tabler/icons-react';
import { ActionIcon, alpha, Group, Text, useMantineTheme } from '@mantine/core';
import { MChatMessageAttachment } from '@/src/modules/chat/models/chat-message-attachment';
import { downloadFileFromUrl } from '@/src/shared/utils/download-file';

interface IChatAttachmentFileProps {
  attachment: MChatMessageAttachment;
}

export function ChatAttachmentFile({ attachment }: IChatAttachmentFileProps) {
  const theme = useMantineTheme();
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const fileNameWithExtension = `${attachment.props.fileName}.${attachment.props.fileExtension}`;

  const downloadFile = async () => {
    if (isDownloading) {
      return;
    }

    setIsDownloading(true);
    await downloadFileFromUrl({
      url: attachment.props.fileUrl,
      fileName: fileNameWithExtension,
    });
    setIsDownloading(false);
  };

  return (
    <Group
      w="100%"
      bdrs="md"
      bg={alpha(theme.colors.gray[4], 0.2)}
      py="0.2rem"
      px="0.4rem"
      gap="sm"
      justify="space-between"
    >
      <Group gap="xs">
        <IconFile color="gray" />
        <Group gap={0}>
          <Text maw="6rem" truncate="end" fz="sm">
            {attachment.props.fileName}
          </Text>
          <Text fz="sm">.{attachment.props.fileExtension}</Text>
        </Group>
      </Group>

      <ActionIcon
        variant="transparent"
        onClick={downloadFile}
        disabled={isDownloading}
      >
        <IconDownload color="gray" />
      </ActionIcon>
    </Group>
  );
}
